import React from "react";
import ConfigSection from "../../ConfigSection";

const AbsenceThresholdSection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Absence Threshold Days'
      configType='AbsenceThreshold'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default AbsenceThresholdSection;
